export default __webpack_public_path__ + "static/media/data_abnormal@2x.b572bbf6.png";